export const errorUtils = {
  deletingReferencedCostCenterNotAllowed: "DELETING_REFERENCED_COST_CENTER_NOT_ALLOWED",
  deletingReferencedSubCostCenterNotAllowed: "DELETING_REFERENCED_SUB_COST_CENTER_NOT_ALLOWED",
  costEstimationInUse: "COST_ESTIMATION_IN_USE",
  existingRole: "ROLE_ALREADY_EXISTS",
  existingEpRole: "EP_ROLE_ALREADY_EXISTS",
  diagnosisCodeAlreadyExists: "DIAGNOSIS_CODE_ALREADY_EXISTS",
  noMandateTariffConfig: "NO_MANDATE_TARIFF_CONFIG",
  invalidInput: "INVALID_INPUT",
  invalidEmail: "INVALID_EMAIL",
  invalidAhvNUmber: "INVALID_AHV_NUMBER",
  duplicateEmail: "DUPLICATE_EMAIL",
  duplicateExternalCode: "INTERVENTION_DUPLICATE_EXTERNAL_CODE",
  employeeEmailAlreadyExists: "EMPLOYEE_EMAIL_ALREADY_EXISTS",
  unknownBAGNumber: "UNKNOWN_BAG_NUMBER",
  deletingReferencedInterventionNotAllowed: "DELETING_REFERENCED_INTERVENTION_NOT_ALLOWED",
  invalidVerificationCode: "INVALID_VERIFICATION_CODE",
  unmetMinimumAge: "UNMET_MINIMUM_AGE",
  invalidToken: "INVALID_TOKEN",
  testResultAlreadySet: "TEST_RESULT_ALREADY_SET",
  testResultNotFound: "TEST_RESULT_NOT_FOUND",
  invalidBarcode: "INVALID_BARCODE",
  unknownBarcode: "UNKNOWN_BARCODE",
  barcodeAlreadyExists: "BARCODE_ALREADY_EXISTS",
  noProcedureGroupTariff: "NO_PROCEDURE_GROUP_TARIFF",
  unknownProcedureGroup: "UNKNOWN_PROCEDURE_GROUP",
  noGuarantorDefined: "NO_GUARANTOR_DEFINED",
  unknownVaccinationRecord: "UNKNOWN_VACCINATION_RECORD",
  poolAlreadySingularized: "POOL_ALREADY_SINGULARIZED",
  identicalTestkitCodeOnSingularization: "IDENTICAL_TESTKIT_CODE_ON_SINGULARIZATION",
  canNotChangeBookingStatus: "CAN_NOT_CHANGE_BOOKING_STATUS",
  unknownInterventionBookingId: "UNKNOWN_INTERVENTION_BOOKING_ID",
  unableToRevokeForCurrentVaccination: "UNABLE_TO_REVOKE_FOR_CURRENT_VACCINATION",
  divisionAlreadyExists: "DIVISION_ALREADY_EXISTS",
  unknownTestKitReceptionOption: "UNKNOWN_TESTKIT_RECEPTION_OPTION",
  testBookingWithCanceledStatus: "TEST_BOOKING_WITH_CANCELED_STATUS",
  deleteTreatmentNotAllowed: "DELETE_TREATMENT_NOT_ALLOWED",
  unknownAnalyzer: "UNKNOWN_ANALYZER",
  vmdlExportEmpty: "VMDL_EXPORT_EMPTY",
  vmdlExportPreviewActionNotAllowed: "VMDL_EXPORT_PREVIEW_ACTION_NOT_ALLOWED",
  automaticPaymentAlreadyInProgress: "AUTOMATIC_PAYMENT_ALREADY_IN_PROGRESS",
  notCompletedInterventionBooking: "NOT_COMPLETED_INTERVENTION_BOOKING",
  canNotVerifyTestResult: "CAN_NOT_VERIFY_TEST_RESULT",
  canNotVerifyTestResultsThatAreNotNegative: "CAN_NOT_VERIFY_TEST_RESULTS_THAT_ARE_NOT_NEGATIVE",
  canNotSetProduct: "CAN_NOT_SET_PRODUCT",
  noPoolInterventionBookingAlreadyHasProduct: "NO_POOL_INTERVENTION_BOOKING_ALREADY_HAS_PRODUCT",
  requiredSpecialProductNotFound: "REQUIRED_SPECIAL_PRODUCT_NOT_FOUND",
  canNotImportTestResultsFromEmptyFile: "CAN_NOT_IMPORT_TEST_RESULTS_FROM_EMPTY_FILE",
  fileWithIncompatibleDataInserted: "FILE_WITH_INCOMPATIBLE_DATA_INSERTED",
  userNotAuthorizedForEditOperation: "USER_NOT_AUTHORIZED_FOR_EDIT_OPERATION",
  mandateNotAllowedToModifyAnotherPatients: "MANDATE_NOT_ALLOWED_TO_MODIFY_ANOTHER_PATIENTS",
  unknownMandate: "UNKNOWN_MANDATE",
  deleteInvoiceNotAllowed: "DELETE_INVOICE_NOT_ALLOWED",
  deletingResourceGroupsNotAllowed: "DELETING_REFERENCED_RESOURCE_GROUP_NOT_ALLOWED",
  deletingResourcesNotAllowed: "DELETING_REFERENCED_RESOURCE_NOT_ALLOWED",
  canNotGetFile: "CAN_NOT_GET_FILE",
  unknownNotification: "UNKNOWN_NOTIFICATION",
  invalidFileType: "INVALID_FILE_TYPE",
  unknownPatient: "UNKNOWN_PATIENT",
  canNotChangeOnHoldStatus: "CAN_NOT_CHANGE_ON_HOLD_BOOKING_STATUS",
  deletingReferencedLocationNotAllowed: "DELETING_REFERENCED_LOCATION_NOT_ALLOWED",
  imageFormatNotSupported: "IMAGE_FORMAT_NOT_SUPPORTED",
  invalidImage: "IMAGE_FORMAT_NOT_SUPPORTED",
  bookingMustBeVerified: "BOOKING_MUST_BE_VERIFIED",
  notCompletedBookingResendEmail: "NOT_COMPLETED_BOOKING_RESEND_EMAIL",
  unknownPatientDocumentId: "UNKNOWN_PATIENT_DOCUMENT_ID",
  unknownDocumentHistory: "UNKNOWN_DOCUMENT_HISTORY",
  employeeNotFound: "EMPLOYEE_NOT_FOUND",
  unknownEmployee: "UNKNOWN_EMPLOYEE",
  invalidFile: "INVALID_FILE",
  canNotImportFileIsEmpty: "CANNOT_IMPORT_FILE_IS_EMPTY",
  canNotUndeleteTreatment: "CAN_NOT_UNDELETE_TREATMENT",
  unableToAcquireLock: "UNABLE_TO_ACQUIRE_LOCK",
  supplierNotFound: "SUPPLIER_NOT_FOUND",
  doctorNotFound: "DOCTOR_NOT_FOUND",
  invalidDocumentId: "INVALID_DOCUMENT_ID",
  unknownPatientEmail: "UNKNOWN_PATIENT_EMAIL",
  invalidDate: "INVALID_DATE",
  canNotSetControlledStatusOnWrongDocumentType: "CAN_NOT_SET_CONTROLLED_STATUS_ON_WRONG_DOCUMENT_TYPE",
  invalidDocumentInput: "INVALID_DOCUMENT_INPUT",
  unknownEmailCampaign: "UNKNOWN_EMAIL_CAMPAIGN",
  notExistingEmailCampaignTemplate: "NOT_EXISTING_EMAIL_CAMPAIGN_TEMPLATE",
  medidataUpdateRemoteStatus: "MEDIDATA_UPDATE_REMOTE_STATUS",
  fileArchiveNotFound: "FILE_ARCHIVE_NOT_FOUND",
  fileArchiveContentEmptyDb: "FILE_ARCHIVE_CONTENT_EMPTY_DB",
  fileArchiveContentEmptyExternal: "FILE_ARCHIVE_CONTENT_EMPTY_EXTERNAL",
  azureServiceIsDown: "AZURE_SERVICE_IS_DOWN"
};
